import { Provider } from '@angular/core';
import { AuthenticationService } from '@auth/services/authentication.service';
import { AuthorityService } from '@auth/services/authority.service';

/**
 * Provides authentication and authority services.
 *
 * This function returns an array of providers for dependency injection,
 * allowing both the AuthenticationService and AuthorityService to be injected
 * throughout the application.
 *
 * @returns An array of providers for authentication and authority services.
 */
export function provideAuth(): Provider[] {
  return [AuthenticationService, AuthorityService];
}
